
import Vue from "vue";
import { namespace } from "vuex-class";
import { Component, Prop, PropSync, Ref } from "vue-property-decorator";
import UserService from "@/services/UserService";

const Notifications = namespace("Notifications");

@Component
export default class RecuperacaoSenhaComponent extends Vue {
  recEmail = "";
  recUser = "";
  isFormValid = false;

  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    email: (v: string) => {
      return /.+@.+\..+/.test(v) || "Insira um e-mail válido";
    },
  };

  voltar(evento: any) {
    if (!evento) return;
    this.$emit("onVoltarPrincipal");
  }

  efetuarRecSenha(evento: any) {
    if (this.isFormValid) {
      UserService.passwordRecoveryRequest({ email: this.recEmail, username: this.recUser }).then(
        (data) => {
          this.showInfoMessage(
            "Instruções de recuperação de senha enviadas para o e-mail do usuário"
          );
          this.voltar({});
        },
        (error) => {
          const message = error.response.data || error.message || error;
          this.showErrorMessage(message);
        }
      );
    }
  }

  onFechar() {
    this.$emit("fecharDialog");
  }
}
